import BaseComponent from 'scripts/BaseComponent.js';
import UnderlayHelper from '../../global/underlay-helper';
import { AccessibilityHelper } from '../../../scripts/accessibility/accessibilityHelper';

export default class ProductRoseOptions extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      drawerToggleBtn: '.js-roseOptionsDrawerToggle',
      viewToggleBtn: '.js-viewToggleBtn',
      valuesWrap: '.js-valuesWrap',
    };

    this.dom = {
      $component: component,
      $drawerToggleBtns: document.querySelectorAll(this.refs.drawerToggleBtn),
      $viewToggleBtns: this.$getAll(this.refs.viewToggleBtn),
      $valuesWrap: this.$get(this.refs.valuesWrap),
    };

    this.state = {
      drawerOpen: false,
      drawerOpenClass: 'open-options',
      underlayHelper: new UnderlayHelper({ overNav: true }),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,

      activeView: 'grid',
      activeViewClass: 'active-view',
      listViewClass: 'list-view',

    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setClick(Array.from(dom.$drawerToggleBtns), this.toggleDrawer);
    this.setClickWithElement(dom.$viewToggleBtns, this.toggleView);
    state.underlayHelper.addClickListener(this.closeDrawer.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
  }

  toggleDrawer() {
    const { state } = this;

    if (state.drawerOpen) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  openDrawer() {
    const { dom, state } = this;

    dom.$component.classList.add(state.drawerOpenClass);
    dom.$component.setAttribute('aria-hidden', 'false');
    dom.$component.setAttribute('aria-expanded', 'true');
    state.underlayHelper.open();
    state.focusTrap.set();
    state.drawerOpen = true;
  }

  closeDrawer() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.drawerOpenClass);
    dom.$component.setAttribute('aria-hidden', 'true');
    dom.$component.setAttribute('aria-expanded', 'false');
    state.underlayHelper.close();
    state.focusTrap.unset();
    state.drawerOpen = false;
  }

  toggleView(btn) {
    const { state } = this;
    const { view } = btn.dataset;
    if (view === state.activeView) return;

    if (view === 'list') {
      this.enableListView(btn);
    } else {
      this.enableGridView(btn);
    }
  }

  enableListView(btn) {
    const { dom, refs, state } = this;

    this.$get(`${refs.viewToggleBtn}[data-view="grid"]`).classList.remove(state.activeViewClass);
    btn.classList.add(state.activeViewClass);
    dom.$valuesWrap.classList.add(state.listViewClass);
    state.activeView = 'list';
  }

  enableGridView(btn) {
    const { dom, refs, state } = this;

    this.$get(`${refs.viewToggleBtn}[data-view="list"]`).classList.remove(state.activeViewClass);
    btn.classList.add(state.activeViewClass);
    dom.$valuesWrap.classList.remove(state.listViewClass);
    state.activeView = 'grid';
  }
}
